<template>
    <el-card>
        <slot></slot>
    </el-card>
</template>
<style scoped>
.el-card {
    box-shadow: none;
}
</style>
<script>
export default {
    name: 'PageBody'
}
</script>
